<template>
    <div>
      <el-form ref="form" :model="form" label-width="130px">
        <el-form-item label="店铺所属大区">
          <el-col :span="6">
            <el-cascader placeholder="所属大区"
              @change="handleOfficeChange"
              :options="this.area.list"
              :props="{ checkStrictly: true }"
              v-model="selected_office_area_id"
              clearable>
            </el-cascader>
          </el-col>
        </el-form-item>
        <el-form-item label="店铺标签">
          <el-col :span="6">
            <el-cascader placeholder="选择标签"
              @change="TagChangeAction"
              :options="this.tag.list"
              :props="{value:'tag_id', label: 'tag_name'}"
              v-model='form.dis_tag_id'
              clearable>
            </el-cascader>
          </el-col>
        </el-form-item>
        <el-form-item label="店铺英克ID">
          <div>
            <el-col :span="14">
              <el-input v-model="form.inca_ids" placeholder="多个店铺ID之间使用英文逗号 ',' 分隔"></el-input>
            </el-col>
          </div>
        </el-form-item>
        <el-form-item label="商品货号">
          <div>
            <el-col :span="4">
              <el-input v-model="form.item_bn"></el-input>
            </el-col>
            <span style="color: #f00;">一次只能设置一个商品的区域划线价</span>
          </div>
        </el-form-item>
        <el-form-item label="商品区域划线价">
          <div>
            <el-col :span="4">
              <el-input type="number" required min="0" v-model="form.area_market_price"></el-input>
            </el-col>
            <span style="color: #f00;">（单位：元）设置为 0 时则取消该商品的区域划线价</span>
          </div>
        </el-form-item>
        <br>
        <div class="section-footer with-border content-center">
          <el-button size="large" @click="cancelSubmit">取消</el-button>
          <el-button type="primary" @click="setAreaMarketPrice" :loading="submitLoading">{{submitLoading ? '提交中' :
            '保存'}}
          </el-button>
        </div>
      </el-form>
    </div>
</template>
<script>
import { setItemAreaMarketPrice } from '@/api/goods'
import { getAreaManageList } from "@/api/areamanage";
import { getTagList } from '@/api/marketing'
export default {
    data() {
      return {
        selected_office_area_id: [],
        loading: false,
        form: {
          item_bn: '',
          inca_ids: '',
          dis_tag_id: 0,
          dis_area_id: 0,
          area_market_price: 0,
        },
        tag: {
          dialog: false,
          list: [],
        },
        area: {
          dialog: false,
          list: [],
        },
        submitLoading: false,
      }
    },
    methods: {
      setAreaMarketPrice() {
        let that = this
        if (!this.form.item_bn) {
          this.$message({message: '请指定商品货号'})
          that.submitLoading = false
          return
        }
        // if (!this.form.area_market_price) {
        //   this.$message({message: '请设置商品区域划线价'})
        //   that.submitLoading = false
        //   return
        // }
        var msg = '是否要设置商品('+ this.form.item_bn +')的区域划线价为('+ this.form.area_market_price +')'
        this.$confirm(msg, '提示', {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          type: 'warning',
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              setItemAreaMarketPrice(this.form).then(res => {
                this.$message({
                  message: res.data.data.message, // '商品区域划线价设置成功',
                  type: 'success',
                  duration: 5 * 1000,
                  onClose() {
                    that.submitLoading = false
                  }
                })
              }).catch(error => {
                that.submitLoading = false
              })
            }
            done()
          }
        })
      },
      // 获取大区数据
      getDataAreaManage() {
        getAreaManageList({'format_flag':true}).then(response => {
          this.area.list = response.data.data;
        })
      },
      // 大区选择
      handleOfficeChange(val) {
        console.log(val);
        this.selected_office_area_id = val
        if (val.length > 1) {
          this.form.dis_area_id = val[1]
        } else {
          this.form.dis_area_id = val[0]
        }
      },
      // 获取店铺标签数据
      getAllTagList () {
        let params = {
          page: 1,
          pageSize: 500
        }
        getTagList(params).then(response => {
          this.tag.list = response.data.data.list
        })
      },
      // 选择店铺标签
      TagChangeAction(tags) {
        this.form.dis_tag_id = tags[0]
      },
      cancelSubmit() {
        this.$router.go(-1)
      },
    },
    mounted() {
      // 获取大区数据
      this.getDataAreaManage()
      // 获取店铺标签数据
      this.getAllTagList()
    }
  }
</script>
<style lang="scss" scoped>
.el-cascader-node {
  width: 500px;
}
</style>




// WEBPACK FOOTER //
// add.vue?15865f4e